import { useApolloClient } from '@common/hooks';
import { useCallback } from 'react';

/**
 * Apollo is not providing a way to refetch outside of mutations
 * in version 2 for no good reason (version 3 has this exposed)
 * this hook uses what's available (but not properly typed) to implement
 * the refetch calls outside of mutation calls
 *
 * it implements basically the same logic here:
 * https://github.com/apollographql/apollo-client/blob/apollo-client%402.6.4/packages/apollo-client/src/core/QueryManager.ts#L289-L314
 *
 * if we ever update apollo we can than just replace this with
 * client.refetchQueries(queries)
 */
export const useApolloClientRefetch = () => {
  const client = useApolloClient();

  // FIXME: we should use DocumentNode here and forbid strings
  return useCallback(
    (refetchQueries: string[]) => {
      client.refetchQueries({
        include: refetchQueries,
      });
    },
    [client]
  );
};
